import { __decorate } from "tslib";
import { VuexModule, Module, Mutation } from 'vuex-module-decorators';
let User = class User extends VuexModule {
    constructor() {
        super(...arguments);
        this.locale = {};
    }
    updateLocale(locale) {
        this.locale = locale || this.locale;
    }
};
__decorate([
    Mutation
], User.prototype, "updateLocale", null);
User = __decorate([
    Module({ namespaced: true, name: 'antLocale' })
], User);
export default User;
